import { Component, EventEmitter, Output } from '@angular/core';
import { OverlayComponentType } from '../../../projects/project.reducer';
import { CanvasService } from '../../../services/canvas/canvas.service';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { getCurrentProjectField } from '../../../projects/project.selector';
import { toggleAiPanel } from '../../ai/store/ai.actions';
import { EditorService } from '../../editor.service';
import { RecorderService } from '../../shape/recorder.service';

@Component({
  selector: 'nw-project-header',
  templateUrl: './project-header.component.html',
  styleUrls: ['./project-header.component.scss'],
})
export class ProjectHeaderComponent {
  editOpen = false;

  projectLabel$: Observable<string>;

  @Output()
  setOverlay = new EventEmitter<OverlayComponentType>();

  constructor(
    public readonly cs: CanvasService,
    private readonly store: Store,
    private readonly recorder: RecorderService,
    private readonly editorService: EditorService,
  ) {
    this.projectLabel$ = this.store.select(getCurrentProjectField('name'));
  }

  startExport() {
    // -- //
    this.recorder.export();
  }

  selectOverlay(type: OverlayComponentType) {
    this.setOverlay.emit(type);
  }

  showColorPalette() {
    this.editorService.overlayConfig = {
      type: 'color-palette',
      callback: value => {
        console.log('color-palette-edit', value);
        // this.store.dispatch(
        //   setDescriptorValue({
        //     key: 'fill',
        //     innerKey: 'color',
        //     value,
        //   }),
        // );
        // this.store.dispatch(bulkUpdateFinish());
      },
    };
  }

  exit() {
    this.cs.resetImage();
    this.cs.router.navigate(['organisations', this.cs.currentOrganisationID]);
  }

  startAIAssistance(event: Event) {
    event.stopPropagation();
    this.store.dispatch(toggleAiPanel({ show: true }));
  }
}
